import { injectable } from 'inversify';
import { useAppSelector } from '../../../../state/hooks';
import { store } from '../../../../state/store';
import {
  assessmentModuleSelector,
  resetAssessment,
  resetAssessmentModuleDetailsForSkip,
  updateAssessmentModule,
  updateAssessmentModuleDetails,
} from './assessmentCreationView.slice';
import { ModuleType } from '../takeAssessment/modules/modules.interface';

interface TrialProps {
  wordsPresented?: string[];
  wordsRecalled?: string[];
  noAnswersCorrect?: boolean;
}
@injectable()
export class AssessmentCreationViewService {
  assessmentModuleSelector = assessmentModuleSelector;
  useModuleSelector = (): ModuleType => {
    return useAppSelector(assessmentModuleSelector);
  };

  dispatchSetAssessmentModule(module: any): void {
    store.dispatch(updateAssessmentModule(module));
  }

  dispatchResetAssessment(): void {
    store.dispatch(resetAssessment());
  }

  dispatchSetAssessmentModuleDetails(
    moduleName: string,
    key: string,
    value: string | number | boolean | string[] | TrialProps | Date,
  ): void {
    if (key === 'skipModuleFlag' && value) {
      store.dispatch(
        resetAssessmentModuleDetailsForSkip({ moduleName, key, value }),
      );
    }
    store.dispatch(updateAssessmentModuleDetails({ moduleName, key, value }));
  }
}
